import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import bin from "../assets/images/bin.png";
import { apiCall } from "../services/AxiosService";
import { API_URL } from "../services/APIRoute";
import { apiResponse } from "../services/APIResponse";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { DeleteMethod } from "../services/ReduxTookit/Slice/DeleteRedux";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

function DisableModal(props) {
  const [Loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  async function fnDelete() {
    setLoading(true);
    let obj = {
      method: props?.method,
      url: API_URL.BASEURL + props?.url,
      payload: props?.payload,
    };
    dispatch(DeleteMethod(obj))?.then((res) => {
      setLoading(false);
      if (res?.payload?.isValidate) {
        // Logic for - Contact List In Work-Flow Screen.
        if (props?.isContactDeleteModelClass) {
          const updatedUsers = props?.contactData.map((user) =>
            user.userid === props?.requiredData
              ? {
                  ...user,
                  workflowroleid: null,
                }
              : user
          );
          props?.setContactData(updatedUsers);
        } else {
          props?.bindlist();
        }
        props?.onHide();
      }
    });
  }

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      // className="delete-modal"
      className={
        props.isContactDeleteModelClass
          ? "contact-add-or-remove-model delete-modal"
          : "delete-modal"
      }
      backdrop="static"
    >
      {Loading && <MainpageLoader/>}
      <Modal.Body>
        <div className="text-center">
          <img src={bin} alt="bin" className="modal-delete-icon" />
          <h4>Are you sure you want to disable?</h4>
          <p>
            Please confirm if you wish to proceed with disable this
            authentication method.
          </p>
          <div className="d-flex align-items-center gap-2">
            <button className="grey-btn" onClick={props.onHide}>
              No, Keep
            </button>
            <button
              className="red-btn"
              onClick={(e) => {
                fnDelete();
              }}
            >
              {Loading ? (
                // <>
                //   <span>Loading</span>{" "}
                //   <Spinner
                //     className="ms-1"
                //     animation="border"
                //     role="status"
                //     size="sm"
                //   >
                //     <span className="visually-hidden">Loading...</span>
                //   </Spinner>
                // </>
                <SubmitLoading />
              ) : (
                " Yes, Disable"
              )}
            </button>
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default DisableModal;
